<template>
  <div>
    <intro v-if="display === $Intro" />
    <guidanceForm v-if="display === $GuidanceForm" />
    <formSummary v-if="display === $FormSummary" />
    <share v-if="display === $Share" />
    <privacyStatement v-if="display === $PrivacyStatement" />
  </div>
</template>

<script>
import jsonData from "./../data/fields.js";

export default {
  name: "Home",
  data() {
    return {
      isapp: false,
      isNativeApp: document.getElementById("isnativeapp"),
      idx: 0,
      display: this.$Intro,
      views: [this.$Intro, this.$GuidanceForm, this.$FormSummary, this.$Share, this.$PrivacyStatement],
      jsonData: jsonData,
      answeredItems: [],
    };
  },
  created() {
    if (this.isNativeApp === undefined || this.isNativeApp === null) {
      console.log("in web open*");
      console.log(this.answeredItems);
      this.isapp = false;
    } else {
      console.log("in app open*");
      this.isapp = true;
    }
    console.log(this.isapp);
  },
  methods: {
    goTo(v) {
      this.views.forEach((e, i) => {
        if (e == v) {
          this.idx = i;
          this.setDisplay();
        }
      });
    },
    setDisplay() {
      window.scrollTo(0, top);
      this.display = this.views[this.idx];
    },
  },
};
</script>